import once from 'transmute/once';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import PlayPauseBtn from '../components/MediaPlayerControls/PlayPauseBtn';
import MediaTimeline from '../variant-default/MediaTimeline';
import { InlineMediaPlayerError } from './InlineMediaPlayerError';
import { composeMediaElement } from '../hoc/composeMediaElement';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getDefaultMediaElement = once(() => composeMediaElement());
export const InlineMediaPlayer = ({
  actionWell,
  onPauseCallback,
  onPlayCallback,
  onSeekCallback,
  HTMLMediaElement
}) => {
  const HTMLMediaElementProxy = useMemo(() => {
    return HTMLMediaElement || getDefaultMediaElement();
  }, [HTMLMediaElement]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HTMLMediaElementProxy, {}), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        flexGrow: 1,
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(InlineMediaPlayerError, {
          children: /*#__PURE__*/_jsxs(Flex, {
            children: [/*#__PURE__*/_jsx(PlayPauseBtn, {
              onPlayCallback: onPlayCallback,
              onPauseCallback: onPauseCallback,
              use: "link"
            }), /*#__PURE__*/_jsx(Box, {
              flexGrow: 1,
              flexShrink: 0,
              paddingInline: "400",
              children: /*#__PURE__*/_jsx(MediaTimeline, {
                variant: "BASIC",
                onDragCallback: onSeekCallback
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        children: actionWell
      })]
    })]
  });
};